import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import FA from 'utils/FA';
import { duckify, filterDuck } from '../../utils/duckify';
import withFiltering from '../../hocs/withFiltering';
import { sharedPortalSherlockUsers } from '../../ducks';
import PageHeader from '../PageHeader';
import './styles/SharedPortalSherlock.scss';
import { titleize } from '../../utils';

const SherlockCard = ({ linkName, header, children }) => (
  <React.Fragment>
    {!!linkName && <a name={linkName} />}
    <h2>{header}</h2>
    <div className='row'>
      <div className='col-24'>
        <div className='card card-body bg-light'>
          {children}
        </div>
      </div>
    </div>
  </React.Fragment>
);

const SherlockTableOfContents = () => (
  <SherlockCard linkName='' header='Table of Contents'>
    <ol>
      <li><a href='#inspection'>Inspection</a></li>
      <li><a href='#detail'>Detail View of Requests</a></li>
    </ol>
  </SherlockCard>
);

const SherlockRequestDetail = ({ user }) => (
  <SherlockCard linkName='detail' header='Detail View of Requests'>
    <a href={user.kibana_query_url} target='_blank' rel='noreferrer'>
      View request history for this user in Kibana
      <FA name='external-link' preNbsp />
    </a>
  </SherlockCard>
);
const SherlockInspection = ({ user }) => (
  <SherlockCard linkName='inspection' header='Inspection'>
    <table className='table table-sm'>
      <tbody>
        {[
          'email', 'sign_in_count', 'current_sign_in_at', 'last_sign_in_at', 'current_sign_in_ip', 'last_sign_in_ip',
          'created_at', 'type', 'acl', 'failed_attempts', 'locked_at', 'id', 'facts_sso_id'
        ].map(col => (
          <tr>
            <th style={{ textAlign: 'left' }}>{titleize(col)}</th>
            <td>{user[col]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </SherlockCard>
);
const SharedPortalSherlock = (
  {
    users,

    // withFilter
    filters,
    setFilters,
  }
) => {
  const [email, setEmail] = useState(filters.email || '');
  const user = users && users[0];

  return (
    <React.Fragment>
      <PageHeader header='Finalsite Explore User Explorer' className='col-12' />

      <div className='row sherlock-email-search'>
        <div className='base-setup-field-label'>Email</div>
        <div className='base-setup-field-value'>
          <input
            className='base-setup-field-input'
            name='email'
            type='text'
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
          />
        </div>
        <div className='col-6'>
          <button type='button' className='btn btn-primary' onClick={() => setFilters({ email })}>
            View User Info
          </button>
        </div>
      </div>

      {!!filters.email && !user && <span>No user found for the given email address.</span>}

      {user && (
        <React.Fragment>
          <h1>{`Inspecting: ${user.first_name} ${user.last_name}`}</h1>
          <br />
          <SherlockTableOfContents user={user} />
          <SherlockInspection user={user} />
          <SherlockRequestDetail user={user} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const mapDucksToProps = ({ filters }) => ({
  users: filterDuck(sharedPortalSherlockUsers, { filters })
});

export default compose(
  withRouter,
  withFiltering,
  duckify(mapDucksToProps)
)(SharedPortalSherlock);
